import backend from '@common/backend';
import { ITableDataQuery } from '@common/models/TableData';

export const groupFromBE = (group: any) =>
	group
		? {
				...group,
				service: group.service_id,
				service_template: group.service_template_id,
			}
		: group;

const BASE = '/cgCoordinators';

export const getCgCoordinators = async (query: ITableDataQuery) =>
	backend.get(`${BASE}/`, {
		params: query,
	});

export const createCgCoordinators = async (data: any) => backend.post(`${BASE}`, data);

export const getCgCoordinator = async (id: number) => backend.get(`${BASE}/${id}`);

export const removeCgCoordinator = async (id: number) => backend.delete(`${BASE}/${id}`);

export const saveCgCoordinator = async (id: number, data: any) =>
	backend.put(`${BASE}/${id}`, data);

export const getCoordinatorsReport = async (data: {
	from: string;
	to: string;
	c_g_class_ids: number[];
}) => backend.post(`${BASE}/report/advanced`, data);
